import React,{ useState , useEffect } from 'react';
import logo from '../../images/logo_purple.png';
import { FormControl } from '@material-ui/core';
import { CustomLabel, CustomTextField,CustomButton } from "@tracknme/material-ui";
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import { cnpjMask } from '../../utils/mask';
import { BrandsApi } from '../../services/Apis';
import alertMessage from '../../services/alertMessage';
import Grid from '@material-ui/core/Grid';
import { cnpj } from 'cpf-cnpj-validator';
import '../../mobile.css';


function Step3() {

  const dispatch = useDispatch();
  
  const { register,navigation } = useSelector(({register}) => register);

  const [name,setName] = useState(null);
  const [nameError,setNameError] = useState(null);
  const [alias,setAlias] = useState(null);
  const [aliasError,setAliasError] = useState(null);
  const [registrationNumber,setRegistrationNumber] = useState(null);
  const [validationRegistrationNumber,setValidationRegistrationNumber] = useState(true);
  const [corporateName,setCorporateName] = useState(null);
  const [corporateNameError,setCorporateNameError] = useState(null);
  const [loadData,setLoadData] = useState(false);
  const [nextStep,setNextStep] = useState(false);


  useEffect(() => {

    if(!loadData && register && register.brand  ){
        
        setName(register.brand.name);
        setAlias(register.brand.alias);
        
        let registrationNumber = cnpjMask(register.brand.registrationNumber);
            setRegistrationNumber(registrationNumber);
        
        if(registrationNumber.length > 17){
          setValidationRegistrationNumber(true);
        }
       
        setCorporateName(register.brand.corporateName);
        setLoadData(true)
        setCorporateNameError(false)
        setCorporateNameError(false)
        setNameError(false)
        dispatch(Actions.setNavigation(false));


      }

  }, [loadData,register,dispatch]);

  const handleChangeNameValue = ({target}) => {
    const {value} = target;
    setName(value);
  }

  const handleChangeAliasValue = ({target}) => {
    const {value} = target;
    setAlias(value);
  }

  const handleChangeRegistrationNumberValue = ({target}) => {
    const {value} = target;
    let registrationNumber = cnpjMask(value);
         setRegistrationNumber(registrationNumber);
  
    if(registrationNumber.length > 17){
      setValidationRegistrationNumber(true);
    }
   
  }

  const handleChangeCorporateNameValue = ({target}) => {
    const {value} = target;
    setCorporateName(value);
  }

  function validateName (){

    if(!name){
      setNameError(true);
      return
    }
    if(name && name.length < 3){
      setNameError(true);
      return
    }

    setNameError(false);
  }

  function validateAlias (){

    if(!alias){
      setAliasError(true);
     return
    }

    setAliasError(true);
    dispatch(Actions.setNavigation(true));

    BrandsApi.checkAlias(alias).then(response => {

      if(response.data === 0){
        setAliasError(false);
      }else{
        alertMessage.showErrorMessage("Esse alias não está disponível!");
        setAliasError(true);
        dispatch(Actions.setNavigation(true));
      }
     
      return
    }).catch(error => {
      setAliasError(true);
      return
    })
  }

  function validateBrandCnpj (){

    let cnpj = registrationNumber.replace(/[^\d]+/g,'');
    BrandsApi.checkRegistrationNumber(cnpj).then(response => {

      if(response.data === 0){
        setValidationRegistrationNumber(true);
      }else{
        alertMessage.showErrorMessage("Esse CNPJ já está cadastrado na Plataforma!");
        setValidationRegistrationNumber(false);
      }
     
      return
    }).catch(error => {
      return
    })
  }

  function validateCorporateName (){

    if(!corporateName){
      setCorporateNameError(true);
      return
    }
    if(corporateName && corporateName.length < 3){
      setCorporateNameError(true);
      return
    }

    setCorporateNameError(false);
   
  }

  function validateCNPJ (){

    if(!registrationNumber){
      setValidationRegistrationNumber(false);
      return
    }

    if(!cnpj.isValid(registrationNumber)){
      setValidationRegistrationNumber(false);
      alertMessage.showErrorMessage("CNPJ inválido!");
      return
    }

    validateBrandCnpj(registrationNumber);

    setValidationRegistrationNumber(false);
    dispatch(Actions.setNavigation(true));
  }

  function changeBackStepValue() {
    dispatch(Actions.setStep(1));
  }
  
  function changeNextStepValue() {
    dispatch(Actions.setStep(3));
  }

  useEffect(() => {
    
    if(name && alias && registrationNumber && registrationNumber.length > 17 && validationRegistrationNumber && corporateName && !aliasError && !corporateNameError && !nameError){
    
      dispatch(Actions.setNavigation(false));
     
      let _register = register;

      let primaryColor = 'mat-fuse-dark-A700-bg'
      let secondColorBrand = 'mat-fuse-dark-A400-bg'

      localStorage.setItem('primaryColorBrand', primaryColor);
      localStorage.setItem('secondColorBrand', secondColorBrand);

      if(_register && _register.brand){
        _register.brand = {
          "parent": 6137206846521344,
          "name": name,
          "alias": alias,
          "corporateName": corporateName,
          "registrationNumber": registrationNumber.replace(/\D/g, ""),
          "companySize":_register.brand.companySize ? _register.brand.companySize :  "",
          "palette":_register.brand.palette ? _register.brand.palette :  "fuse-dark",
          "purposeOfUse":_register.brand.purposeOfUse ? _register.brand.purposeOfUse :  []
        }
      }else{
        _register = {
          'brand' : {
            "parent": 6137206846521344,
            "name": name,
            "alias": alias,
            "corporateName": corporateName,
            "registrationNumber": registrationNumber.replace(/\D/g, ""),
            "companySize":"",
            "palette":"fuse-dark",
            "purposeOfUse":[]
          }
        }
      }

      _register["payment"] = {
        "type": "BOOKLET"
      }

      _register.skipCnaeCheck=false;
      _register.offer = '5891544202084352';

      dispatch(Actions.setRegister(_register));
      setNextStep(true);
      
    }else if(!navigation){
      setNextStep(false);
    }
  
  }, [name, alias, registrationNumber, corporateName,validationRegistrationNumber,register,dispatch,aliasError,corporateNameError,nameError,navigation ]);



  return (
    <div className="menuMobile">
        <div className="containerMobile">
        
            <div className="containerImage" >
                <img src={logo} className="logo" alt="Trackn'Me" />
            </div>
      
            <div className="titleStep3" >
                <CustomLabel  label="Vamos começar coletando alguns dados da sua empresa:" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:700, color:'#4D39E9'}} />  
            </div>

             <div className="textField">
                <FormControl>
                    <CustomTextField  label="Nome da Empresa:" value={name}  name="inputOne_1" onBlur={() => validateName()} onChange={handleChangeNameValue} variant="filled" placeholder="Nome da Empresa" style={{width:'84vw'}} error={nameError}/>
                    <CustomTextField  label="Alias da Marca (voce.dominiodamarca.com.br):"  value={alias}  name="alias_1" onFocus={() => setAliasError(true)} onBlur={() => validateAlias()}  onChange={handleChangeAliasValue}  variant="filled" placeholder="Insira o alias da empresa" style={{width:'84vw'}} error={aliasError}/> 
                    <CustomTextField  label="Razão Social:"  value={corporateName} onBlur={() => validateCorporateName()} name="rs_1"  onChange={handleChangeCorporateNameValue}  variant="filled" placeholder="Razão Social" style={{width:'84vw'}} error={corporateNameError}/>  
                    <CustomTextField  label="CNPJ:"  value={registrationNumber} onFocus={() => setValidationRegistrationNumber(false)} onBlur={() => validateCNPJ()}  name="cnpj_1"  onChange={handleChangeRegistrationNumberValue}  variant="filled" placeholder="00.000.000/0000-00" style={{width:'84vw'}} error={!validationRegistrationNumber} />  
                </FormControl>
                <div style={{height:100}}></div>  
            </div>
         
          
        </div>

        <div className="footer">
          <Grid container spacing={1}>
            <Grid item xs={4}  >
             
              <div className="center">
                <CustomButton   disabled={false} onClick={() => changeBackStepValue()} variant="contained" color="primary" label="Voltar" style={{height:'40px',marginTop:'20px', color:'#4D39E9', backgroundColor:'white', border: '3px solid #4D39E9'}}/> 
              </div>
            </Grid>
            <Grid item xs={4} >
              <div className="center">
                <CustomLabel  label=" Passo 2 – 6" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:400, color:'#929292', marginTop:'35px'}} />  
              </div>
            </Grid>
            <Grid item xs={4} >
            <div className="center"><CustomButton   disabled={false} onClick={() => nextStep ? changeNextStepValue() : {}} variant="contained" color="primary" label="Avançar" style={nextStep ? {height:'40px',marginTop:'20px'} : {height:'40px',marginTop:'20px',backgroundColor:'#BFBFBF'}}/> </div>
            </Grid>
          </Grid>
          
        </div>
        
       
        
     </div>
    
  );
}

export default Step3;

